import {
  IDocumentDetailField,
  IPolygon,
} from 'common/document/interfaces/document-detail-field';

export type IFieldPolygon = { [key: string]: IPolygon[] | null };

export const buildFieldPolygon = (
  inputData: IDocumentDetailField[] | null | undefined
): IFieldPolygon | null => {
  if (!inputData?.length || !Object.keys(inputData).length) {
    return null;
  }
  return Object.values(inputData).reduce(
    (hash: { [key: string]: any }, currentValue: any) => {
      hash[currentValue.fieldName] =
        currentValue?.imageRecognitionBoundingBox?.Polygon || null;
      return hash;
    },
    {}
  );
};
